import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { ResponseApi } from '../../../../dtos/response-api';
import { AtrDadosOrgao, Notificacao } from '../../../../dtos/sai/controladoria/atr-dados-orgao';
import { AtrDadosDimensoesAtendidas, GetAtrDadosDimensoesAtendidas } from '../../../../dtos/sai/controladoria/atr-dados-dimensoes-atendidas';
import { AtrDadosOrgaoHistorico, GetAtrDadosOrgaoHistorico } from '../../../../dtos/sai/controladoria/atr-dados-orgao-historico';
import { AtrDadosOrgaoSnapshot } from '../../../../dtos/sai/controladoria/atr-dados-orgao-snapshot';
import { AtrDadosDimensoesPorMunicipio, GetAtrDadosDimensoesPorMunicipio } from '../../../../dtos/sai/controladoria/atr-dados-dimensoes-por-municipio';
import { AtrDadosOrgaoAvaliacaoHistorico } from '../../../../dtos/sai/controladoria/atr-dados-orgao-avaliacao-historico';
import { AtrIndicadores } from '../../../../dtos/sai/controladoria/atr-indicadores';
import { AtrPlanosAcao } from '../../../../dtos/sai/controladoria/atr-plano-acao';


@Injectable({
  providedIn: 'root'
})
export class AtrDadosService {

  private baseUrl = `${environment.apiUrl}/sai/controladoria/AtrDados`;
  private dimensoesSubject = new BehaviorSubject<AtrDadosDimensoesPorMunicipio[] | null>(null);

  constructor(private http: HttpClient) { }

  // getDimensoesAtendidas(get: GetAtrDadosDimensoesAtendidas): Observable<ResponseApi<AtrDadosDimensoesAtendidas[]>> {
  //   const params = new HttpParams({ fromObject: { itemAvaliacao: get.itemAvaliacao } });
  //   return this.http.get<ResponseApi<AtrDadosDimensoesAtendidas[]>>(`${this.baseUrl}/getDimensoesAtendidas`, { params });
  // }

  getDimensoesAtendidas(): Observable<ResponseApi<AtrDadosDimensoesAtendidas[]>> {
    return this.http.get<ResponseApi<AtrDadosDimensoesAtendidas[]>>(`${this.baseUrl}/getDimensoesAtendidas`);
  }

  getDimensoesPorMunicipio(get: GetAtrDadosDimensoesPorMunicipio): Observable<ResponseApi<AtrDadosDimensoesPorMunicipio[]>> {
    const params = new HttpParams({
      fromObject: {
        codMunicipioMun: get.codMunicipioMun,
        itemAvaliacao: get.itemAvaliacao
      }
    });
    return this.http
      .get<ResponseApi<AtrDadosDimensoesPorMunicipio[]>>(
        `${this.baseUrl}/getDimensoesPorMunicipio`,
        { params }
      )
      .pipe(
        tap((response: ResponseApi<AtrDadosDimensoesPorMunicipio[]>) => {
          if (response.success) {
            this.dimensoesSubject.next(response.data); // cache no service
          }
        })
      );
  }

  // expõe o observable para outros componentes
  getDimensoesCache(): Observable<AtrDadosDimensoesPorMunicipio[] | null> {
    return this.dimensoesSubject.asObservable();
  }

  getDadosHistorico(get: GetAtrDadosOrgaoHistorico): Observable<ResponseApi<AtrDadosOrgaoHistorico[]>> {
    const params = new HttpParams({ fromObject: { data: get.data.toISOString().split('T')[0] } });
    return this.http.get<ResponseApi<AtrDadosOrgaoHistorico[]>>(`${this.baseUrl}/getDadosHistorico`, { params });
  }

  getDados(): Observable<ResponseApi<AtrDadosOrgao[]>> {
    return this.http.get<ResponseApi<AtrDadosOrgao[]>>(`${this.baseUrl}/getDados`);
  }

  getSnapshot(): Observable<ResponseApi<AtrDadosOrgaoSnapshot[]>> {
    return this.http.get<ResponseApi<AtrDadosOrgaoSnapshot[]>>(`${this.baseUrl}/getSnapshot`);
  }

  getNotificacoes(): Observable<ResponseApi<Notificacao[]>> {
    return this.http.get<ResponseApi<Notificacao[]>>(`${this.baseUrl}/getNotificacoes`);
  }

  getAvaliacaoHistorico(): Observable<ResponseApi<AtrDadosOrgaoAvaliacaoHistorico[]>> {
    return this.http.get<ResponseApi<AtrDadosOrgaoAvaliacaoHistorico[]>>(`${this.baseUrl}/getAvaliacaoHistorico`);
  }

  getIndicadores(): Observable<ResponseApi<AtrIndicadores[]>> {
    return this.http.get<ResponseApi<AtrIndicadores[]>>(`${this.baseUrl}/getIndicadores`);
  }

  getPlanos(): Observable<ResponseApi<AtrPlanosAcao[]>> {
    return this.http.get<ResponseApi<AtrPlanosAcao[]>>(`${this.baseUrl}/getPlanos`);
  }
}
